import posthog from 'posthog-js';

let initialized = false;

export function initAnalytics() {
  const key = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
  if (!key || initialized) return;

  posthog.init(key, {
    api_host: (import.meta.env.VITE_POSTHOG_HOST as string | undefined) || 'https://app.posthog.com',
    capture_pageview: true,
    autocapture: false,
    loaded: () => {
      initialized = true;
    },
  });
}

export function identifyUser(userId: string, properties?: Record<string, unknown>) {
  if (!posthog.__loaded) return;
  posthog.identify(userId, properties);
}

export function resetAnalyticsUser() {
  if (!posthog.__loaded) return;
  posthog.reset();
}

export type FunnelEvent =
  | 'signup_started'
  | 'signup_completed'
  | 'first_generation_started'
  | 'first_generation_completed'
  | 'first_download'
  | 'first_roblox_export'
  | 'first_marketplace_listing'
  | 'first_sale'
  | 'subscription_started'
  | 'subscription_churned'
  | 'refill_purchased'
  | 'generation_failed'
  | 'generation_refunded'
  | 'generation_started'
  | 'generation_completed'
  | 'roblox_export_started'
  | 'roblox_export_success'
  | 'roblox_export_failed'
  | 'roblox_optimization_started'
  | 'roblox_optimization_completed'
  | 'download_clicked'
  | 'marketplace_listing_started'
  | 'checkout_started'
  | 'checkout_completed';

export function track(event: FunnelEvent, properties?: Record<string, unknown>) {
  try {
    if (posthog.__loaded) {
      posthog.capture(event, properties);
    }
  } catch {
    // never throw from analytics
  }
}
